<template>
  <div class="card mb-3">
    <div class="card-header py-2">
      <h6 class="mb-0">
        <font-awesome-icon icon="gift" class="me-2" />
        Gutscheincode (optional)
      </h6>
    </div>
    <div class="card-body p-3">
      <p class="text-muted mb-2 small">
        {{ description }}
      </p>
      <div class="input-group">
        <input
          v-model="couponCode"
          type="text"
          class="form-control"
          placeholder="Gutscheincode eingeben"
          :disabled="couponLoading"
          @input="onCouponCodeChange"
        />
        <button
          class="btn btn-outline-primary"
          type="button"
          :disabled="!couponCode.trim() || couponLoading"
          @click="validateCoupon"
        >
          <span
            v-if="couponLoading"
            class="spinner-border spinner-border-sm me-2"
            role="status"
          ></span>
          <font-awesome-icon v-else icon="check" class="me-2" />
          {{ couponLoading ? 'Prüfe...' : 'Prüfen' }}
        </button>
      </div>

      <!-- Coupon Result -->
      <div v-if="couponResult" class="mt-2">
        <div v-if="couponResult.success" class="alert alert-success alert-sm">
          <div class="d-flex align-items-center">
            <font-awesome-icon icon="check-circle" class="me-2" />
            <div>
              <strong>{{ couponResult.data.coupon.name }}</strong>
              <div class="small">{{ getCouponDescription(couponResult.data.coupon) }}</div>
              <div v-if="showAdditionalInfo && couponResult.data.coupon.type === 'free_team_pro' && !selectedPlan" class="small text-muted mt-1">
                <font-awesome-icon icon="info-circle" class="me-1" />
                Du kannst jetzt "Weiter" klicken oder einen Plan auswählen.
              </div>
            </div>
          </div>
        </div>
        <div v-else class="alert alert-danger alert-sm">
          <div class="d-flex align-items-center">
            <font-awesome-icon icon="exclamation-triangle" class="me-2" />
            <span>{{ couponResult.error }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useCoupon } from '../composables/useCoupon'

const props = defineProps({
  description: {
    type: String,
    default: 'Hast du einen Gutscheincode? Gib ihn hier ein, um Rabatte zu erhalten.'
  },
  couponType: {
    type: String,
    default: 'coin_purchase'
  },
  selectedPlan: {
    type: Object,
    default: null
  },
  showAdditionalInfo: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['coupon-validated', 'coupon-cleared'])

const {
  couponCode,
  couponLoading,
  couponResult,
  validateCoupon: validateCouponFn,
  getCouponDescription,
  onCouponCodeChange: onCouponCodeChangeFn
} = useCoupon()

const validateCoupon = async () => {
  await validateCouponFn(props.couponType)
  emit('coupon-validated', couponResult.value)
}

const onCouponCodeChange = () => {
  onCouponCodeChangeFn(() => {
    emit('coupon-cleared')
  })
}
</script>

<style scoped>
.alert-sm {
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
}
</style>
